import { createFileRoute } from "@tanstack/react-router";

import OnboardingPage from "@/pages/onboarding/OnboardingPage";

import {
  redirectIfOnboarded,
  requiresCurrentUser,
  requiresWorkOSAuth,
} from "@/providers/auth/utils";

export const Route = createFileRoute("/onboarding")({
  beforeLoad: ({ context, location }) => {
    requiresWorkOSAuth(context, location);
    requiresCurrentUser(context, location);
    redirectIfOnboarded(context);
  },
  component: OnboardingRouteComponent,
});

function OnboardingRouteComponent() {
  return <OnboardingPage />;
}
